import DashboardMonthData from './DashboardMonthData';
import DashboardMonthFilter from './DashBoardDropdownComp';

const DashboardWrapperProductivity = ({ title, children, monthData, showMonth = true, showDropdown = true, onMonthChange, filterData }) => {

  return (
    <>
      <div className="h-auto xl:col-span-2">
        <div className="flex items-center justify-between dark:text-white-light mb-5">
          <h5 className="font-semibold text-lg">{title}</h5>
          {/* {showMonth && <DashboardMonthData filterData={filterData} />}
          {showDropdown && (
            <DashboardMonthFilter
              onOptionClick={(option) => {
                onMonthChange(option); // Update selected month in parent component
              }}
            />
          )} */}
        </div>
        {children}
      </div>
    </>
  );
};

export default DashboardWrapperProductivity;
